import type { DayTripPlanDefault_EditPageQuery, LangCode } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { NameOfResourceBeingEdited } from "@/components/features/_components";
import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { ProductExistingDayTripPlanFormModelContextProvider } from "./context";
import { useInitialized } from "../../model/usecase/existing/use-init";
import { DayTripPlanFormMain } from "../_shared/components/root";
import { dayTripPlanCategoriesAndManagerStore } from "../_shared/store/categories";
import { HeaderActions } from "./components/header/actions";

type Props = {
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
	serverModel: DayTripPlanDefault_EditPageQuery;
};

export const DayTripPlanEditPresenter = ({ activeLangCode, navigator, serverModel }: Props) => {
	const init = useInitialized({ serverModel });

	const { categoryManagerStore } = dayTripPlanCategoriesAndManagerStore;

	const { isDirty } = init.viewModel;
	useTransitionBlock(isDirty);

	const planName = init.viewModel.name.value;

	return (
		<ProductExistingDayTripPlanFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="日帰りプラン編集"
					activeLangCode={activeLangCode}
					navigator={navigator}
					rightChildren={<HeaderActions />}
				/>
				<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
					{/* @todo Layout の共通化が出来るまでは共通化しない */}
					<NameOfResourceBeingEdited resourceName={planName} />

					<DayTripPlanFormMain dayTripPlanCategoriesAndManagerStore={dayTripPlanCategoriesAndManagerStore} />
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</ProductExistingDayTripPlanFormModelContextProvider>
	);
};

DayTripPlanEditPresenter.displayName = "DayTripPlanEditPresenter";
